import {initInView} from "./helpers";

document.querySelectorAll('[data-block-layout="header"]').forEach($el => {
    import('../../../partials/layout/header/header' /* webpackChunkName: "/dist/js/header" */).then(({default: init}) => init($el));
});

document.querySelectorAll('[data-block-layout="menu-mobile"]').forEach($el => {
    import('../../../partials/layout/menu-mobile/menu-mobile' /* webpackChunkName: "/dist/js/menu-mobile" */).then(({default: init}) => init($el));
});

document.querySelectorAll('[data-js="carousel-team"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/carousel/carousel-team' /* webpackChunkName: "/dist/js/carousel-team" */).then(({default: init}) => init($el));
    });
});

document.querySelectorAll('[data-js="carousel-testimonials"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/carousel/carousel-testimonials' /* webpackChunkName: "/dist/js/carousel-testimonials" */).then(({default: init}) => init($el));
    });
});

document.querySelectorAll('[data-block="gallery"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/gallery/gallery' /* webpackChunkName: "/dist/js/gallery" */).then(({default: init}) => init($el));
    });
});

document.querySelectorAll('[data-block="gallery-grid"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/gallery-grid/gallery-grid' /* webpackChunkName: "/dist/js/gallery-grid" */).then(({default: init}) => init($el));
    });
});

document.querySelectorAll('[data-fancybox]').forEach($el => {
    initInView($el).then(() => {
        import('./common/fancybox-image' /* webpackChunkName: "/dist/js/fancybox-image" */).then(({default: init}) => init($el));
    });
});

document.querySelectorAll('[data-block="openstreet-map"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/openstreet-map/openstreet-map' /* webpackChunkName: "/dist/js/openstreet-map" */).then(({default: init}) => init($el));
    });
});

document.querySelectorAll('[data-block="slider"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/slider/slider' /* webpackChunkName: "/dist/js/slider" */).then(({default: init}) => init($el));
    });
});

document.querySelectorAll('[data-block="carousel-partners"] [data-block="carousel"]').forEach($el => {
    initInView($el).then(() => {
        import('../../../partials/blocks/carousel-partners/carousel-partners' /* webpackChunkName: "/dist/js/carousel-partners" */).then(({default: init}) => init($el));
    });
});
